module.exports = "/_next/static/images/shortcuts-cb3328f5ceb82a4de9a073798efbbaa9.png";